module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "150px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "h3-sub-title"
  }, [_vm._v("Nos recommandations pour la création d’un message clair et impactant :")]), _vm._v(" "), _c('div', {
    staticClass: "h4-sub-title"
  }, [_vm._v("Format :")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("Votre création doit avoir un format horizontal (plus large que haut) et occuper la totalité de lʼécran pour proﬁter au mieux des possibilités de votre écran.")]), _vm._v(" "), _c('div', {
    staticClass: "h4-sub-title"
  }, [_vm._v("Illustration :")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("Une photographie ou une illustration permettent de remplacer un texte descriptif. Un message intégrant une image est mieux mémorisé que sʼil est simplement constitué de texte.")]), _vm._v(" "), _c('div', {
    staticClass: "h4-sub-title"
  }, [_vm._v("Texte :")]), _vm._v(" "), _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("A chaque passage, votre message est diffusé 6 secondes. Ce temps imparti est court, pour être lu et mémorisé, votre texte doit lʼêtre aussi. Lʼutilisation de différentes tailles de caractères ou de caractères gras permet de mettre en valeur les éléments importants. Les informations présentes, type numéro de téléphone, horaires,…, doivent être bien visibles. Vériﬁez que les textes positionnés directement sur une image de fond ou sur un fond de couleur, \"se détachent bien\".")]), _vm._v(" "), _c('div', {
    staticClass: "h4-sub-title"
  }, [_vm._v("Couleur :")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "750px"
    }
  }), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h2-arrow"
  }, [_vm._v("CONSEILS"), _c('br'), _vm._v("PRATIQUES")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-12"
  }, [_vm._v("\n    Une bonne utilisation des couleurs permet de mettre en valeur des informations, en revanche lʼabus nuit à la lisibilité."), _c('br'), _vm._v("\n    En règle générale :"), _c('br'), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "orange-list"
  }, [_vm._v("nʼutilisez pas plus de 5 couleurs différentes dans le même document car au delà, lʼassociation couleur/information ne se fait plus")]), _vm._v(" "), _c('li', {
    staticClass: "orange-list"
  }, [_vm._v("choisissez des couleurs qui se marient bien entre elles (plusieurs sites internet donnent des conseils sur leurs associations)")]), _vm._v(" "), _c('li', {
    staticClass: "orange-list"
  }, [_vm._v("pour qu'un texte soit lisible, il faut un bon contraste : contraste clair/sombre et/ou contraste sur la teinte des couleurs (par ex. le jaune et le vert ont un moins bon contraste que le jaune et le rouge)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-10 col-md-offset-1 contraintes-techniques"
  }, [_c('div', {
    staticClass: "h3-sub-title green-inverse"
  }, [_vm._v("Contraintes techniques :")]), _vm._v(" "), _c('p', {
    staticClass: "green-inverse"
  }, [_c('strong', [_vm._v("Attention, votre création doit respecter certains paramètres :")])]), _vm._v(" "), _c('ul', {
    staticClass: "green-inverse"
  }, [_c('li', {
    staticClass: "orange-list"
  }, [_vm._v("Poids maximum : 1 Mo")]), _vm._v(" "), _c('li', {
    staticClass: "orange-list"
  }, [_vm._v("Taille recommandée : 1024 x 668 pixels ou 36 cm x 24 cm (largeur x hauteur)")]), _vm._v(" "), _c('li', {
    staticClass: "orange-list"
  }, [_vm._v("Format : JPEG ou PNG (pas de PDF, Word, Power Point...)")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "var(--fifth-color)",
      "height": "1px",
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "green-inverse",
    staticStyle: {
      "text-align": "center",
      "font-style": "italic"
    }
  }, [_vm._v("Si vous rencontrez des difﬁcultés pour adapter votre message à nos formats,"), _c('br'), _vm._v("contactez nous par mail : "), _c('a', {
    staticStyle: {
      "font-weight": "bold",
      "color": "var(--secondary-color)"
    },
    attrs: {
      "href": "mailto: votre-espace.adgency@orisha.com"
    }
  }, [_vm._v(" votre-espace.adgency@orisha.com")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-412ff03e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-412ff03e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConseilsPratiques.vue
// module id = 193
// module chunks = 1